import React, { Fragment } from 'react'
import { TouchableOpacity, Modal } from 'react-native'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'
import DialogueMarkdown from 'APP/Components/DialogueMarkdown'
import I18n from 'APP/I18n'
import { Metrics, Colors } from 'APP/Themes'
import {
  ContentStyles,
  HeaderContainer,
  MarkdownStyles,
  ModalContainer,
  TitleH1,
  TitleH2,
} from './style'
import { ResponsiveScrollView } from 'APP/Converse/Layout'
import styled from 'styled-components/native'

const CloseButton = styled(TouchableOpacity)`
  padding: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  margin-left: ${({ theme }) => -(theme.metrics.baseMargin * 0.75)}px;
  margin-top: ${({ theme }) => -(theme.metrics.baseMargin * 0.75)}px;
`

interface FAQModalProps {
  isVisible: boolean
  onClose: () => void
}

const FAQModal: React.FC<FAQModalProps> = ({ isVisible, onClose }) => {
  return (
    <Modal
      statusBarTranslucent
      animationType="slide"
      transparent
      visible={isVisible}
      onRequestClose={onClose}
      testID="FAQ_MODAL"
    >
      <ModalContainer>
        <HeaderContainer>
          <CloseButton onPress={onClose}>
            <MaterialIcon name="close" size={Metrics.icons.small} color={Colors.text} />
          </CloseButton>
        </HeaderContainer>
        <ResponsiveScrollView contentContainerStyle={ContentStyles}>
          <TitleH1 variant="h1">{I18n.t('ActiveMinutes.faq.header')}</TitleH1>
          {(
            I18n.t('ActiveMinutes.faq.content', { returnObjects: true }) as {
              header: string
              markdown: string
            }[]
          ).map(({ header, markdown }) => (
            <Fragment key={header}>
              <TitleH2 variant="h2" color="accent">
                {header}
              </TitleH2>
              <DialogueMarkdown markdown={markdown} styles={MarkdownStyles} containerStyles={{}} />
            </Fragment>
          ))}
        </ResponsiveScrollView>
      </ModalContainer>
    </Modal>
  )
}

export default FAQModal
